import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'
import { ApolloQueryResult } from '@apollo/client';

export function useGetLastUpdatedFunc() {

  const {
    load: getLastUpdatedLoad,
    refetch: getLastUpdatedRefetch,
    onResult: getLastUpdatedOnResult,
    onError: getLastUpdatedOnError
  } = useLazyQuery<
    api.AggregateStockItemQuery,
    api.AggregateStockItemQueryVariables
  >(api.AggregateStockItemDocument, undefined)

  const getLastUpdatedFetchOrRefetch = async (variables:api.AggregateStockItemQueryVariables) => {
    return await getLastUpdatedLoad(api.AggregateStockItemDocument, variables, {
      fetchPolicy: 'network-only',
    }) || await getLastUpdatedRefetch(variables)
  }

  const getLastUpdated = async () => {
    // 検索実行
    const res = await getLastUpdatedFetchOrRefetch({})
    const res1 = res as api.AggregateStockItemQuery
    const res2 = res as ApolloQueryResult<api.AggregateStockItemQuery>
    if (res &&  res1.aggregateStockItem?._max?.updatedAt) {
      return res1.aggregateStockItem?._max?.updatedAt as Date
    } else if (res && res2.data?.aggregateStockItem?._max?.updatedAt) {
      return res2.data?.aggregateStockItem?._max?.updatedAt as Date
    } else {
      return undefined
    }
  }

  return {
    getLastUpdated,
    getLastUpdatedOnResult,
    getLastUpdatedOnError
  }
}
